function showMenu() {
  document.getElementById('header').onclick = (e) => {
    e.stopPropagation();
    const { className } = e.target;
    const classList = ['header__menu', 'hamburger', 'hamburger__item'];
    if (classList.includes(className)) {
      document.getElementById('menu-wrap').classList.add('menu-visible');
    }
  };
}

function hideMenu() {
  document.getElementById('menu__btn-close').onclick = (e) => {
    // e.stopPropagation();
    document.getElementById('menu-wrap').classList.remove('menu-visible');
    resetIconMenu();
  };
}

document.addEventListener('keydown', function(event){
	if(event.key === "Escape"){
    document.getElementById('menu-wrap').classList.remove('menu-visible');
    resetIconMenu();
	}
});

function resetIconMenu() {
  document.getElementById('menu__icon').src = '/wp-content/themes/ate/img/menu/menu-icon.svg';
}

function generateIconMenu() {
  const iconMenu = document.getElementById('menu__icon');
  const url = '/wp-content/themes/ate/img/menu/';
  const icons = {
    aboutIcon: 'about-icon.svg',
    servicesIcon: 'services-icon.png',
    projectsIcon: 'project-icon.svg',
    clientsIcon: 'clients-icon.svg',
    articlesIcon: 'articles-icon.svg',
    contactsIcon: 'contacts-icon.svg',
  };

  Object.keys(icons).forEach((key) => {
    let element = document.getElementsByClassName(key)[0];
    element.onmouseover = (e) => {
      iconMenu.src = url + icons[key];
    }
  })
}

function changeHamburgerColor() {
  const hamburger = document.getElementById('hamburger');
  const menuWord = document.getElementById('header__menu');
  const clientHeight = window.innerHeight;
  let isNeedStyle = true;
  let heightForChangeColor = null;

  if (window.location.pathname !== '/') {
    heightForChangeColor = 90;
  } else {
    heightForChangeColor = clientHeight - 70;
  }

  const switchStyle = (color) => {
    [].forEach.call(hamburger.children, (child) => {
      if (color) {
        child.style.backgroundColor = '#164e64';
        menuWord.style.display = 'none';
      } else {
        child.removeAttribute('style');
        menuWord.style.display = 'block';
      }
    });
  };

  document.body.onscroll = (e) => {
    e.stopPropagation();

    if (heightForChangeColor - window.pageYOffset < 0) {
      isNeedStyle && switchStyle('#164e64');
      isNeedStyle = false;
    } else {
      !isNeedStyle && switchStyle(null);
      isNeedStyle = true;
    }
  };
}

function openProjectsDescription() {

  document.querySelectorAll('.project__item').forEach(item => {
    item.addEventListener('click', event => {
      let previews = document.querySelectorAll('.project__preview');
      let descriptions = document.querySelectorAll('.project__description');

      let preview = item.getElementsByClassName('project__preview')[0];
      let description = item.getElementsByClassName('project__description')[0];

      let keep = true;
      if (preview.classList.contains('active') && description.classList.contains('active')) {
        keep = false;
      }

      previews.forEach(item => {
        item.classList.remove('active');
      })
      descriptions.forEach(item => {
        item.classList.remove('active');
      })

      if (keep){
        preview.classList.add('active');
        description.classList.add('active');
      }
    })
  })

  // 'li' with id='project-item-{number from 1 to ...}'
  // first-child 'div' element with id='project-preview'
  // second-child 'div' element with id='project-description'

  let projectsList = document.getElementById('projects-list');
  if (projectsList){
    let widthList = projectsList.clientWidth;
    const heightItem = 220;
    const widthItem = 330;
    let countItemsPerRow = Math.floor(widthList / widthItem);
    let prevElement = null;

    window.onresize = (e) => {
      e.stopPropagation();
      projectsList = document.getElementById('projects-list');
      widthList = projectsList.clientWidth;
      countItemsPerRow = Math.floor(widthList / widthItem);
      removeStyles(prevElement);
    };

    function setStyles(el) {
      const id = el.id.split('-').pop();
      let topPosition;
      if (screen.width < 415){
        topPosition = heightItem;
        widthList = false;
      } else {
        topPosition = Math.ceil(id / countItemsPerRow) * heightItem;
      }
      const preview = el.getElementsByClassName('project__preview')[0];
      const description = el.getElementsByClassName('project__description')[0];
      const heighDescription = description.clientHeight;
      preview.classList.add('active');
      description.style.width = `${widthList}px`;
      description.style.top = `${topPosition}px`;
      description.classList.add('active');
      el.style.marginBottom = `${heighDescription}px`;
    }

    function removeStyles(el) {
      const preview = el.getElementsByClassName('project__preview')[0];
      const description = el.getElementsByClassName('project__description')[0];
      preview.classList.remove('active');
      description.classList.remove('active');
      description.removeAttribute('style');
      el.removeAttribute('style');
    }

    projectsList.onclick = (e) => {
      const liElement = e.target.closest('li');

      if (prevElement) {
        removeStyles(prevElement);
      }

      if (prevElement === liElement) {
        removeStyles(liElement);
        prevElement = null;
        return;
      }

      setStyles(liElement);
      prevElement = liElement;
    };
  }
}

showMenu();
hideMenu();
generateIconMenu();
changeHamburgerColor();
openProjectsDescription();

jQuery(document).ready(function($) {
  // Set preferred slidesToShow
  let clientsSlidesToShow = 7;
  let clientsChildElements = $('.clients__logos').children().length;
  // Check if we can fulfill the preferred slidesToShow
  if( clientsSlidesToShow > (clientsChildElements-1) ) {
    // Otherwise, make slidesToShow the number of slides - 1
    // Has to be -1 otherwise there is nothing to scroll for - all the slides would already be visible
    clientsSlidesToShow = (clientsChildElements-1);
  }

  // $('.clients__logos').slick({
  //   centerMode: false,
  //   slidesToShow: clientsSlidesToShow,
  //   swipeToSlide: true,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   dots: false,
  //   arrows: false,
  //   infinite: true,
  //   speed: 1000,
  //   responsive: [
  //     {
  //       breakpoint: 1370,
  //       settings: {
  //         centerMode: false,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: false,
  //         arrows: false,
  //       }
  //     },
  //     // You can unslick at a given breakpoint now by adding:
  //     // settings: "unslick"
  //     // instead of a settings object
  //   ]
  // });

  // Set preferred slidesToShow
  let feedbackSlidesToShow = 3;
  let feedbackChildElements = $('.slider__list').children().length;
  // Check if we can fulfill the preferred slidesToShow
  if( feedbackSlidesToShow >= (feedbackChildElements) ) {
    // Otherwise, make slidesToShow the number of slides - 1
    // Has to be -1 otherwise there is nothing to scroll for - all the slides would already be visible
    feedbackSlidesToShow = 1;
  }

  // $('.slider__list').slick({
  //   centerMode: true,
  //   slidesToShow: feedbackSlidesToShow,
  //   swipeToSlide: true,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   dots: false,
  //   arrows: true,
  //   prevArrow: '.slider__button-prev',
  //   nextArrow: '.slider__button-next',
  //   infinite: true,
  //   speed: 1000,
  //   responsive: [
  //     {
  //       breakpoint: 1370,
  //       settings: {
  //         centerMode: false,
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: false,
  //         arrows: true,
  //         prevArrow: '.slider__button-prev',
  //         nextArrow: '.slider__button-next',
  //       }
  //     },
  //     // You can unslick at a given breakpoint now by adding:
  //     // settings: "unslick"
  //     // instead of a settings object
  //   ]
  // });

  $('#add-clients-to-list').on('click', function () {
    $('.clients__item').removeClass('hidden');
    $(this).addClass('hidden');
  })

  $("a[href='#to_top']").click(function() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });
});
